<template>
    <div class="animated fadeIn">
        <b-card>
            <div class="d-flex justify-content-between">
                <span class="mb-0 font-weight-bold" style="font-size: 16px">
                    <i class="fa fa-fw fa-refresh mr-2" />Sinkron Master Data
                </span>
                <b-button
                    size="md"
                    class="ml-2"
                    variant="success"
                    v-b-tooltip.hover.top
                    v-b-tooltip.no-delay
                    :title="btnTitle"
                    :disabled="isDisabled"
                    @click="confirmToggle(null)"
                >
                    <i
                        class="fa fa-fw fa-refresh"
                        :class="{ 'fa-spin': isSubmitting[4] }"
                    />
                    Sinkron Semua
                </b-button>
            </div>
            <hr />

            <b-table
                bordered
                hover
                show-empty
                :items="masterItems"
                :fields="fields"
                responsive
                class="mb-3"
                id="local-table"
                :current-page="currentPage"
            >
                <template v-slot:empty> Tidak ada data master. </template>
                <template v-slot:cell(name)="row">
                    <span>{{ row.item.name }}</span>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button
                        size="sm"
                        class="ml-2"
                        variant="success"
                        v-b-tooltip.hover.top
                        v-b-tooltip.no-delay
                        :title="btnTitle"
                        :disabled="isDisabled"
                        @click="confirmToggle(row.item)"
                    >
                        <i
                            class="fa fa-fw fa-refresh"
                            :class="{ 'fa-spin': isSubmitting[row.item.id] }"
                        />
                    </b-button>
                </template>
            </b-table>

            <PageSizer
                :totalRows="masterItems.length"
                :page="currentPage"
                :options="options"
                @limit-change="onLimitChange"
                @page-change="onPageChange"
            />
        </b-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            isDisabled: false,
            isSubmitting: [false, false, false, false, false],
            btnTitle: "Sinkron",

            options: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 30, text: "30" },
                { value: 40, text: "40" },
                { value: 50, text: "50" },
            ],

            fields: [
                { key: "name", label: "Nama Master", sortable: true },
                { key: "action", label: "Aksi", sortable: false },
            ],

            masterItems: [
                {
                    id: 0,
                    name: "Item Kind",
                    value: "SYNC_ITEM_KIND",
                },
                {
                    id: 1,
                    name: "Item Brand",
                    value: "SYNC_ITEM_BRAND",
                },
                {
                    id: 2,
                    name: "Item Spec",
                    value: "SYNC_ITEM_SPEC",
                },
                {
                    id: 3,
                    name: "Item Type",
                    value: "SYNC_ITEM_TYPE",
                },
            ],

            currentPage: 1,
            pageLength: 0,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,
        };
    },

    methods: {
        confirmToggle(val) {
            this.btnTitle = "";
            this.isDisabled = true;
            if (val === null) {
                this.isSubmitting[4] = true;
            } else {
                this.isSubmitting[val.id] = true;
            }
            let value = val === null ? val : val.value;
            let name = val === null ? "Semua Item" : val.name;
            let payload = {
                syncType: value,
            };

            this.$axios
                .post("syncMasterData", payload)
                .then((_) => {
                    this.$helper.toastSuccess(
                        this,
                        name + " berhasil di sinkronkan!"
                    );
                })
                .catch((error) => this.$helper.parseError(this, error))
                .finally(() => {
                    this.btnTitle = "Sinkron";
                    this.isDisabled = false;
                    if (val === null) {
                        this.isSubmitting[4] = false;
                    } else {
                        this.isSubmitting[val.id] = false;
                    }
                });
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage;
            this.getItems(this.currentPage);
        },

        onPageChange(newPage) {
            this.currentPage = newPage;
            this.getItems(this.currentPage);
        },
    },
};
</script>
